import { formatToCNPJAlphanumeric, formatToCPF, isCNPJ, isCPF } from 'brazilian-values-v2'

const customBodyRender = (value) => {
  if (isCPF(value)) return formatToCPF(value)
  if (isCNPJ(value)) return formatToCNPJAlphanumeric(value)

  return value
}

export const columnsCpfs = [
  {
    name: 'cpf',
    label: 'CPF',
    options: {
      customBodyRender: customBodyRender,
    },
  },
]

export const columnsCnpjs = [
  {
    name: 'cnpj',
    label: 'CNPJ',
    options: {
      customBodyRender: customBodyRender,
    },
  },
]
